import { type MetaFunction, json, redirect } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import "app/styles/styles.css";
import Parser from "rss-parser";
import { z } from "zod";

const parseCoverImage = (content: string) => {
	const match = content.match(/<img[^>]+src="([^">]+)"/);
	return match ? match[1] : "";
};

export const loader = async ({ request }: { request: Request }) => {
	const feed = await new Parser().parseURL(
		"https://medium.com/feed/@echowebblogs",
	);

	const guid = new URL(request.url).searchParams.get("guid");

	if (!guid) {
		return redirect("/blog");
	}
	const post = feed.items.find((item) => item.guid?.includes(guid));

	if (!post) {
		throw new Response("Not Found", { status: 404 });
	}

	const parsedPost = z
		.object({
			title: z.string().min(1),
			link: z.string().url(),
			coverImage: z.string().url(),
			publishedAt: z.string().min(1),
			content: z.string(),
		})
		.parse({
			title: post.title,
			link: post.link,
			coverImage: parseCoverImage(post["content:encoded"]),
			publishedAt: post.pubDate,
			content: post["content:encoded"],
		});
	return json({ post: parsedPost });
};

export const meta: MetaFunction<typeof loader> = ({ data }) => [
	{ title: data ? `${data.post.title} | Aplikace Echo` : "Aplikace Echo" },
];

export default function Post() {
	const { post } = useLoaderData<typeof loader>();

	return (
		<div className="container lg:pb-7 pb-64 h-full">
			<div className=" font-bold text-center leading-10 mb-8 lg:font-extrabold lg:leading-[56px] text-4xl lg:mb-12">
				{post.title}
			</div>

			<div className="prose lg:prose-xl mx-auto">
				{/* biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation> */}
				<div dangerouslySetInnerHTML={{ __html: post.content }} />
			</div>
		</div>
	);
}
